import { useTranslation } from "react-i18next";
import BasicButton from "../../../components/BasicButton";
import { itemTypes } from "../../../data/types/itemTypes";
import { colors } from "../../../data/colors";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloudIcon from "@mui/icons-material/Cloud";
import BlockIcon from "@mui/icons-material/Block";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ChatIcon from "@mui/icons-material/Chat";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useMainContext } from "../../../context/MainContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useEffect, useRef, useState } from "react";
import { sendData } from "../../../services/sendData";
import { stdObject } from "../../../data/types/stdObject";
import { openDownloadModal } from "../functions/openDownloadModal";
import { downloadOrders } from "../functions/downloadOrders";
import ChatModal from "../../../components/ChatModal/ChatModal";

export default function MenuHeader({
  askLogout,
  changeBranch,
  activeDoc,
  alarms,
  chatUnread,
}: {
  askLogout: () => void;
  changeBranch: () => void;
  activeDoc: number;
  alarms: number;
  chatUnread: number;
}) {
  const { t } = useTranslation();
  const [download, setDownload] = useState<stdObject>({
    internet: "ok",
    total: 0,
  });
  const user: any = useSelector((state: RootState) => state.data.user);
  const {
    mainMenuheader,
    setMainMenuHeader,
    openActiveDocList,
    openNotifications,
    openCalendar,
    setMsg,
    setModalData,
    setModalData2,
    closeMsg,
    logoutAction,
  } = useMainContext();
  const { type, Icon } = mainMenuheader;

  const downloadClickLock = useRef(false);
  const [checkingDownload, setCheckingDownload] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  const checkDownload = async (reschedule: boolean = true) => {
    const responseDownload = await sendData({
      endPoint: "checkDownload",
      logoutAction,
    });
    // console.log("responseDownload: ", responseDownload);

    let seconds = 10;
    const { success, status, total, error } = responseDownload;
    if (success && status) {
      seconds = 5;
      const tempDownload = download;
      if (tempDownload.internet !== true) {
        tempDownload.internet = true;
      }
      tempDownload.total = total;
      setDownload({ ...tempDownload });
    } else {
      if (download.internet !== error) {
        setDownload({
          ...download,
          internet: error ?? "error",
        });
      }
    }
    if (reschedule) {
      setTimeout(checkDownload, seconds * 60000);
    }
  };

  const startDownloadOrders = () =>
    downloadOrders({
      t,
      user,
      download,
      setDownload,
      setMsg,
      setModalData,
      setModalData2,
      closeMsg,
      logoutAction,
    });

  const handleDownloadClick = async () => {
    if (!download.internet) {
      return false;
    }
    if (downloadClickLock.current) {
      return;
    }
    downloadClickLock.current = true;
    try {
      if (download.total > 0) {
        await startDownloadOrders();
      } else {
        setCheckingDownload(true);
        try {
          await checkDownload(false);
        } finally {
          setCheckingDownload(false);
        }
      }
    } finally {
      downloadClickLock.current = false;
    }
  };

  useEffect(() => {
    if (user.DWNUSU) {
      checkDownload();
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: type in colors ? colors[type] : colors.lightGrey2,
      }}
    >
      <div style={{ flex: 1, padding: 3 }}>
        {typeof type === "string" ? (
          <div
            className="screenBar"
            onClick={() =>
              setMainMenuHeader({
                type: false,
                id: "",
                Icon: CheckBoxOutlineBlankIcon,
              })
            }
          >
            <div className="iconBar">
              <Icon />
            </div>
            <span style={{ fontSize: 22 }}>{t(`p.${type}`)}</span>
          </div>
        ) : (
          <div
            className="screenBar"
            style={{ cursor: user.MULUSU ? "pointer" : "default" }}
            onClick={user.MULUSU ? changeBranch : () => {}}
          >
            {user.NOMSUC}
          </div>
        )}
      </div>
      {!!user.DWNUSU && (
        <div
          style={{ position: "relative", cursor: "pointer" }}
          onClick={handleDownloadClick}
        >
          {checkingDownload ? (
            <AutorenewIcon
              className="webDownloadIcon spinIcon"
              style={{
                marginTop: 5,
                color: colors.lightGrey,
              }}
            />
          ) : download.internet === true ? (
            <CloudDownloadIcon
              className="webDownloadIcon"
              style={{
                transform: "translateY(5px)",
                color:
                  download.total > 0 ? colors.lightGreen2 : colors.lightGrey,
              }}
            />
          ) : (
            <CloudIcon
              className="webDownloadIcon"
              style={{
                transform: "translateY(0px)",
                color: colors.lightGrey,
              }}
            />
          )}
          <div className="webDownloadText">
            {download.internet === true ? (
              download.total
            ) : !download.internet ? (
              <PriorityHighIcon
                style={{
                  position: "absolute",
                  top: 6,
                  left: 8,
                  fontSize: 14,
                  color: colors.red,
                }}
              />
            ) : (
              <BlockIcon
                style={{
                  position: "absolute",
                  top: 6,
                  left: 8,
                  fontSize: 14,
                  color: colors.red,
                }}
              />
            )}
          </div>
        </div>
      )}
      {!!user.ALAROL && (
        <div style={{ padding: 3, marginRight: 10 }}>
          <BasicButton
            onClick={openNotifications}
            title={alarms.toString()}
            color={
              alarms > 20 ? colors.red : alarms > 0 ? colors.green : colors.grey
            }
            Icon={alarms > 0 ? NotificationsActiveIcon : NotificationsIcon}
            iconClassName={alarms > 0 ? "notificationRing" : ""}
          />
        </div>
      )}
      <div style={{ padding: 3, marginRight: 10 }}>
        <BasicButton
          onClick={() => setChatOpen(true)}
          title={chatUnread > 0 ? chatUnread.toString() : ""}
          color={chatUnread > 0 ? colors.green : colors.grey}
          Icon={chatUnread > 0 ? ChatIcon : ChatBubbleOutlineIcon}
          iconClassName={chatUnread > 0 ? "notificationRing" : ""}
        />
      </div>
      {!!user.CALROL && (
        <div style={{ padding: 3, marginRight: 10 }}>
          <BasicButton
            onClick={openCalendar}
            color={colors.green}
            Icon={CalendarMonthIcon}
          />
        </div>
      )}
      {!!activeDoc && (
        <div id="activeDocButton" style={{ padding: 3, marginRight: 10 }}>
          <BasicButton
            onClick={openActiveDocList}
            title={activeDoc.toString()}
            color={colors.red}
            Icon={InsertDriveFileIcon}
          />
        </div>
      )}
      <div style={{ padding: 3 }}>
        <BasicButton
          onClick={askLogout}
          title={t("p.logout")}
          color={colors.red}
          Icon={PowerSettingsNewIcon}
        />
      </div>
      <ChatModal open={chatOpen} onClose={() => setChatOpen(false)} />
    </div>
  );
}
